import { useState, useEffect } from 'react';
import { config } from './config';
import '../../index.css';
import chip from '../../assets/images/chip.png';
import cardBg from '../../assets/images/cardBg.png';
import DeleteIcon from '@mui/icons-material/Delete';
import Radio from '@mui/material/Radio';
import {
  Card,
  CardContent,
  Button,
  makeStyles,
  Tooltip,
} from '@material-ui/core';
import './Billing.css';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useDispatch, useSelector } from 'react-redux';
import { userState } from '../../store';
import { handleError } from '../../utils/config';
import { useHistory } from 'react-router';
import CarIcon from '../../assets/images/car.png';
import PlanIcon from '../../assets/images/airplane.png';
import RocketIcon from '../../assets/images/rocket.png';
import FreeTrial from '../../assets/images/free-trial.png';
import AlertModal from '../../components/Modals/Alert/Alert';
import { userActions } from '../../store/userSlice';
import BuyNow from '../../components/Modals/BuyNow/BuyNow';
import { Plan } from '../../schemas/billing.schema';
import { RoutesFun } from '../../schemas';
import './Billing.css';
import Loading from '../../components/Loading/Loading';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';

interface PlanData {
  [planName: string]: string[];
}

// Define styles using makeStyles
const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(3),
  },

  titleBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  cardBorder: {
    width: '400px',
    height: '240px',
    backgroundColor: '#F6F6F6',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)',
    padding: '15px 15px',
    borderRadius: '15px',
  },
  activeCardBorder: { 
    border: '3px solid #34A853',
    boxShadow: '0 8px 24px rgba(52, 168, 83, 0.25)',
  },
  iconSize: { 
    width: '80px', 
    height: '80px',
    objectFit: 'contain',
  },
  card: {
    width: '30%',
    margin: 'auto',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(2),
    borderRadius: '16px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
    border: '2px solid #f0f0f0',
    transition: 'all 0.3s ease',
    overflow: 'hidden',
    '&:hover': {
      transform: 'translateY(-8px)',
      boxShadow: '0 12px 32px rgba(0, 0, 0, 0.12)',
    },
  },
  cardFourPerRow: {
    flex: '1 1 23%',
    maxWidth: '23%',
  },
  bgGreen: {
    background: 'linear-gradient(135deg, #E2FFF2 0%, #B8F5D8 100%)',
    padding: '32px 24px',
    borderRadius: '12px 12px 0 0',
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '4px',
      background: 'linear-gradient(90deg, #34A853 0%, #0F9D58 100%)',
    },
  },

  buttonWidth: { width: '100%' },
  bgBlue: {
    background: 'linear-gradient(135deg, #E3F2FD 0%, #BBDEFB 100%)',
    padding: '32px 24px',
    borderRadius: '12px 12px 0 0',
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '4px',
      background: 'linear-gradient(90deg, #1976D2 0%, #0D47A1 100%)',
    },
  },
  content: {
    flex: 1,
    padding: '0 !important',
  },
  currency: {
    color: 'green',
  },
  title: {
    fontSize: '28px',
    fontWeight: 700,
    color: '#1a1a1a',
    marginBottom: '8px',
    letterSpacing: '-0.5px',
  },
  cardTitle: {
    fontSize: '20px',
    fontWeight: 400,
  },
  feature: {
    width: '85%',
    padding: '16px 0',
    textAlign: 'left',
    fontSize: '15px',
    lineHeight: '15px',
    color: '#4a4a4a',
    fontWeight: 400,
  },
  button: {
    alignItems: 'center',
    fontSize: '16px',
    fontWeight: 600,
    backgroundColor: '#0078DB',
    color: theme.palette.common.white,
    padding: '12px 24px',
    borderRadius: '8px',
    textTransform: 'none',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#0066BB',
      transform: 'scale(1.02)',
    },
  },

  cancelSubButton: {
    width: '85%',
    alignItems: 'center',
    marginTop: theme.spacing(2),
    backgroundColor: '#DC3545',
    color: theme.palette.common.white,
    fontWeight: 600,
    padding: '10px 24px',
    borderRadius: '8px',
    textTransform: 'none',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#BB2D3B',
    },
  },
  disabledButton: {
    alignItems: 'center',
    backgroundColor: '#4BB543',
    color: 'white',
    cursor: 'default',
    fontWeight: 600,
    padding: '12px 24px',
    borderRadius: '8px',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#45A03D',
    },
  },
  loadingButton: {
    alignItems: 'center',
    cursor: 'default',
    fontWeight: 600,
    padding: '12px 24px',
    textTransform: 'none',
  },
  infoButton: {
    alignItems: 'center',
    cursor: 'help',
    backgroundColor: '#0078DB',
    color: theme.palette.common.white,
    fontWeight: 600,
    padding: '12px 24px',
    borderRadius: '8px',
    textTransform: 'none',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#1976d2',
    },
  },
  editButton: {
    width: '40%',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    color: theme.palette.common.white,
    background: 'slategrey',
    '&:hover': {
      backgroundColor: '#5B707F',
    },
  },
  deleteButton: {
    width: '2vw',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    color: theme.palette.common.white,
    background: '#dc4545',
    '&:hover': {
      backgroundColor: 'red',
    },
  },
  subscriptionButton: {
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    fontWeight: 700,
  },
  root: {
    width: '400px',
    height: '240px',
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[3],
    padding: theme.spacing(1),
    color: '#b7b7b7',
  },
  cardImg: {
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundImage: `url(${cardBg})`,
    borderRadius: '15px',
  },
  cardLogo: {
    marginBottom: theme.spacing(2),
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItem: 'center',
    height: 'auto',
    margin: 'auto',
  },
  cardNumber: {
    fontSize: '19px',
    marginBottom: theme.spacing(3),
    fontWeight: 600,
    display: 'flex',
    letterSpacing: '4px',
    alignItems: 'center',
    justifyContent: 'center',
  },
  cardInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
  },
  font700: {
    fontWeight: 700,
  },
  cardBox: {
    height: '250px',
    display: 'flex',
    overflowX: 'scroll',
  },
  marchantLogo: {
    width: '34%',
    aspectRatio: '3/2',
    objectFit: 'contain',
    mixBlendMode: 'color',
  },
  pendingButton: {
    width: '85%',
    display: 'flex',
    justifyContent: 'center',
    fontWeight: 600,
    alignItems: 'center',
    height: '35px',
    alignContent: 'center',
    backgroundColor: '#FFF9C4',
    borderRadius: '8px',
    color: '#F57F17',
    border: '1px solid #FBC02D',
  },
  insidePendingText: {
    margin: '2.8% 25%',
  },
  planWithPriceSection: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    width: '70%',
  },
  planHeaderSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    minHeight: '140px',
  },
  planIconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    borderRadius: '16px',
    padding: '16px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
  },
  priceSection: {
    display: 'flex',
    alignItems: 'baseline',
    gap: '4px',
    marginTop: '12px',
  },
  priceSymbol: {
    fontSize: '32px',
    fontWeight: 700,
    color: '#1a1a1a',
  },
  priceAmount: {
    fontSize: '48px',
    fontWeight: 800,
    color: '#1a1a1a',
    lineHeight: '1',
    letterSpacing: '-1px',
  },
  featuresSection: {
    padding: '32px 24px',
    backgroundColor: '#fafafa',
    minHeight: '300px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  featureDivider: {
    width: '100%',
    height: '1px',
    backgroundColor: '#e0e0e0',
    margin: '8px 0',
  },
  buttonsSection: {
    padding: '24px',
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'row',
    // alignItems: 'center',
    gap: '12px',
    borderTop: '1px solid #f0f0f0',
  },
}));

const getIconForPlan: any = {
  Basic: CarIcon,
  Growth: PlanIcon,
  'Growth+': RocketIcon,
  'Free Trial': FreeTrial,
};

const useRadioStyles = makeStyles(() => ({
  largeRadio: {
    '& svg': {
      fontSize: '2rem',
    },
    '& span': {
      fontSize: '1.5rem',
    },
  },
}));

const Billing = () => {
  const [networkError, setNetworkError] = useState('');
  const history = useHistory();
  const user = useSelector(userState)?.userData;
  const [loader, setLoader] = useState(false);
  const [cardsData, setCardsData] = useState<any>({});
  const [deleteCardId, setDeleteCardId] = useState<string>('');
  const [plan, setPlan] = useState<any>();
  const [plansData, setPlansData] = useState<Plan[]>([]);
  const [buyModal, setBuyModal] = useState(false);
  const [cancelSubsModal, setCancelSubsModal] = useState(false);
  const [deleteCardModal, setDeleteCardModal] = useState<boolean>(false);
  const [requestQuoteModal, setRequestQuoteModal] = useState<boolean>(false);
  const [companyDetail, setCompanyDetail] = useState<any>();
  const [autoRenewal, setAutoRenewal] = useState(false);
  const [planChange, setPlanChange] = useState(false);
  const [plansInfo, setPlansInfo] = useState<PlanData>({});
  const Routes = RoutesFun();
  const dispatch = useDispatch();
  const userDataState = useSelector(userState).userData;

  const onCloseBuyModal = () => setBuyModal(false);
  const onCloseCancelSubsModal = () => setCancelSubsModal(false);
  const onDeleteCardModal = () => setDeleteCardModal(false);
  const onRequestQuoteModal = () => setRequestQuoteModal(false);

  const getCardDetails = async () => {
    try {
      const stripId = user?.stripe_customer_id;
      setLoader(true);
      if (stripId) {
        const result = await config.getCard(stripId);
        if (
          result?.result &&
          Object.keys(result?.result).length &&
          typeof result?.result !== 'string'
        ) {
          if (result?.result.defaultCard)
            result.result.defaultCard = {
              ...result.result.defaultCard,
              IsActive: true,
            };
          setCardsData(result.result);
        }
      }
    } catch (e: any) {
      setNetworkError(e === 'Network Error' ? e : '');
      if (e && e.error && e.error.message) {
        handleError(e, history);
      }

      throw e;
    } finally {
      setLoader(false);
    }
  };

  const setAsDefault = async (PaymentMethodId: string) => {
    try {
      setLoader(true);

      const params = {
        stripe_customer_id: user?.stripe_customer_id,
        PaymentMethodId,
      };
      const result = await config.setAsDefault(params);
      if (result.message) {
        dispatch(
          userActions.replaceUserState({
            successMessage: result.message,
          })
        );
      }
    } catch (e: any) {
      setNetworkError(e === 'Network Error' ? e : '');
      if (e && e.error && e.error.message) {
        handleError(e, history);
      }

      throw e;
    } finally {
      getCardDetails();
      setLoader(false);
    }
  };

  const getPlanConfig = async () => {
    setLoader(true);
    try {
      const apiResponse = await config.getPlansInfo();

      const transformedPlans = apiResponse.reduce((acc: any, plan: any) => {

        const featureTexts = plan.plan_description
          .map((f: any) => f.description?.trim())
          .filter((desc: string) => !!desc);

        acc[plan.name] = [...featureTexts];
        return acc;
      }, {});

      setPlansInfo(transformedPlans);
    } catch (error) {
      console.error('Error fetching plan config:', error);
      throw error;
    }
    setLoader(false);
  };


  const getPlanDetails = async () => {
    try {
      const companyName = user?.CompanyName;
      const result = await config.getPlans(companyName);
      setPlansData(result);
    } catch (e: any) {
      if (e && e.error && e.error.message) {
        handleError(e, history);
      }
      throw e;
    } finally {
      setLoader(false);
    }
  };

  const getCompanyPlan = async () => {
    try {
      const companyName = user?.CompanyName;
      const result = await config.getCompanyPlan(companyName);
      setPlansData(result);
    } catch (e: any) {
      if (e && e.error && e.error.message) {
        handleError(e, history);
      }
      throw e;
    } finally {
      setLoader(false);
    }
  };

  const classes = useStyles();
  const radioClasses = useRadioStyles();

  useEffect(() => {
    if (user) {
      getPlanConfig();
      getCardDetails();
      getCompanyPlan();
      getCompanyDetails();
    }
  }, [user]);

  const getCompanyDetails = async () => {
    try {
      const result = await config.companyDetails();
      if (result) {
        setAutoRenewal(
          result.SubscriptionMode === 'Auto Renewal' ? true : false
        );
        setCompanyDetail(result);
      }
    } catch (e: any) {
      setNetworkError(e === 'Network Error' ? e : '');
      if (e && e.error && e.error.message) {
        handleError(e, history);
      }

      throw e;
    } finally {
      setLoader(false);
    }
  };

  const handleBillingCheckout = async (selectedAutoRenew: boolean) => {
    try {
      setLoader(true);

      const planData: Plan[] = plansData?.filter(
        (planObj: any) => planObj.name === plan
      );

      const result = await config.createCheckout(
        user?.stripe_customer_id,
        planData[0]?.stripe_plan_id,
        user?.PlanType,
        companyDetail?.PlanSubscriptionId,
        !selectedAutoRenew,
        companyDetail?.SubscriptionStatus
      );

      if (result) {
        if (result.sessionMessage) window.open(result.sessionMessage, '_self');

        if (result.noCardMsg) {
          dispatch(
            userActions.replaceUserState({
              errorMessage: result.noCardMsg,
            })
          );
          return;
        }
        setBuyModal(false);
        dispatch(
          userActions.replaceUserState({
            successMessage: result.message,
          })
        );

        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (e: any) {
      setNetworkError(e === 'Network Error' ? e : '');
      if (e && e.error && e.error.message) {
        dispatch(
          userActions.replaceUserState({
            errorMessage: e.error.message.message,
          })
        );
        handleError(e, history);
      }

      throw e;
    } finally {
      setLoader(false);
    }
  };

  const handleCancelSubscription = async () => {
    try {
      setLoader(true);
      const result = await config.cancelSubscription(
        companyDetail?.PlanSubscriptionId
      );
      if (result) {
        setCancelSubsModal(false);

        dispatch(
          userActions.replaceUserState({
            successMessage: result.message,
          })
        );

        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (e: any) {
      setNetworkError(e === 'Network Error' ? e : '');
      if (e && e.error && e.error.message) {
        handleError(e, history);
      }

      throw e;
    } finally {
      setLoader(false);
    }
  };

  if (networkError) {
    throw new Error(networkError);
  }

  const handleAddCard = async () => {
    try {
      const stripId = user?.stripe_customer_id;
      setLoader(true);
      const result = await config.addCard(stripId);
      if (result) {
        window.open(result, '_self');
      }
    } catch (e: any) {
      if (e && e.error && e.error.message) {
        handleError(e, history);
      }
      throw e;
    } finally {
      setLoader(false);
    }
  };

  const handleRequestQuoteModal = async () => {
    try {
      setLoader(true);
      const companyName = user?.CompanyName;
      const result = await config.requestQuoteModal(companyName, plan);
      if (result) {
        setRequestQuoteModal(false);
        dispatch(
          userActions.replaceUserState({
            successMessage: result.message,
          })
        );
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (e: any) {
      setNetworkError(e === 'Network Error' ? e : '');
      if (e && e.error && e.error.message) {
        handleError(e, history);
      }

      throw e;
    } finally {
      setLoader(false);
    }
  };

  const handleDeleteCard = async () => {
    try {
      setLoader(true);
      const result = await config.deleteCard(deleteCardId);
      if (result) {
        setDeleteCardModal(false);
        dispatch(
          userActions.replaceUserState({
            successMessage: result.message,
          })
        );

        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (e: any) {
      setNetworkError(e === 'Network Error' ? e : '');
      if (e && e.error && e.error.message) {
        handleError(e, history);
      }

      throw e;
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      <div className="mb-10">
        <div
          className="inventoryHeader mb-10"
          style={{ borderBottom: '1px solid #eaeaea' }}
        >
          <span className="inventoryHeading font-26px fw-300">
            Card Details
          </span>
        </div>
        {loader ? (
          <Loading style={{ height: '30vh' }} />
        ) : (
          <div className=" ml-25 cardOuterCont">
            <div className="flex">
              {cardsData?.defaultCard &&
                Object.keys(cardsData?.defaultCard).length ? (
                <div>
                  <Card className={`${classes.root} ${classes.cardImg} mr-20`}>
                    <CardContent>
                      <div className={classes.cardLogo}>
                        <img
                          style={{ marginTop: '10px' }}
                          src={chip}
                          alt="chip logo"
                          height="30"
                        />
                        <img
                          className={classes.marchantLogo}
                          src={`https://logo.clearbit.com/${cardsData?.defaultCard?.card.brand}.com`}
                          alt={`${cardsData?.defaultCard?.card.brand} logo`}
                          height="50"
                        />
                      </div>
                      <p className={classes.cardNumber}>
                        **** **** **** {cardsData?.defaultCard?.card.last4}
                      </p>
                      <div className={classes.cardInfo}>
                        <p className={classes.font700}>Exp:</p>
                        <p className={classes.font700}>
                          {cardsData?.defaultCard?.card.exp_month}/
                          {cardsData?.defaultCard?.card.exp_year}
                        </p>
                      </div>
                      <div className={classes.cardInfo}>
                        <p className={classes.font700}>Card Brand:</p>
                        <p className={classes.font700}>
                          {cardsData?.defaultCard?.card.brand?.toUpperCase()}
                        </p>
                      </div>
                    </CardContent>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-around',
                      }}
                    >
                      <Button
                        className={classes.deleteButton}
                        onClick={() => {
                          setDeleteCardId(cardsData?.defaultCard.id);
                          setDeleteCardModal(true);
                        }}
                      >
                        <DeleteIcon style={{ fontSize: '18px' }} />
                      </Button>
                    </div>
                  </Card>
                  <div className="ml-90">
                    <Tooltip title="Default payment card">
                      <Radio
                        className={`ml-90 mt-10 ${radioClasses.largeRadio}`}
                        checked={cardsData?.defaultCard.IsActive}
                      />
                    </Tooltip>
                  </div>
                </div>
              ) : (
                <></>
              )}
              {Object.keys(cardsData).length &&
                cardsData.nonDefaultCards.length ? (
                cardsData.nonDefaultCards.map(
                  (eachCard: any, index: number) => (
                    <div key={eachCard.id + index}>
                      <Card
                        className={`${classes.root} ${classes.cardImg} mr-20`}
                      >
                        <CardContent>
                          <div className={classes.cardLogo}>
                            <img
                              style={{ marginTop: '10px' }}
                              src={chip}
                              alt="chip logo"
                              height="30"
                            />
                            <img
                              className={classes.marchantLogo}
                              src={`https://logo.clearbit.com/${eachCard.card.brand}.com`}
                              alt={`${eachCard.card.brand} logo`}
                              height="50"
                            />
                          </div>
                          <p className={classes.cardNumber}>
                            **** **** **** {eachCard.card.last4}
                          </p>
                          <div className={classes.cardInfo}>
                            <p className={classes.font700}>Exp:</p>
                            <p className={classes.font700}>
                              {eachCard.card.exp_month}/{eachCard.card.exp_year}
                            </p>
                          </div>
                          <div className={classes.cardInfo}>
                            <p className={classes.font700}>Card Brand:</p>
                            <p className={classes.font700}>
                              {eachCard.card.brand?.toUpperCase()}
                            </p>
                          </div>
                        </CardContent>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-around',
                          }}
                        >
                          <Button
                            className={classes.deleteButton}
                            onClick={() => {
                              setDeleteCardId(eachCard.id);
                              setDeleteCardModal(true);
                            }}
                          >
                            <DeleteIcon style={{ fontSize: '18px' }} />
                          </Button>
                        </div>
                      </Card>
                      <div className="ml-90">
                        <Tooltip title="Set as default">
                          <Radio
                            className={`ml-90 mt-10 ${radioClasses.largeRadio}`}
                            onClick={() => setAsDefault(eachCard.id)}
                            checked={false}
                          />
                        </Tooltip>
                      </div>
                    </div>
                  )
                )
              ) : (
                <></>
              )}
            </div>
            <div>
              <Card className={classes.cardBorder}>
                <CardContent>
                  <p className={`${classes.cardTitle} mb-25`}>Add A New Card</p>
                  <p className="font-16px mb-10  " style={{ color: 'gray' }}>
                    Go to add card for create a new card.
                  </p>
                  <p className="font-16px  " style={{ color: 'gray' }}>
                    You can add, edit and delete card any time.
                  </p>
                </CardContent>
                <Button
                  variant="contained"
                  onClick={handleAddCard}
                  className={`${classes.button} mt-15  mb-15 ml-15 w-90`}
                >
                  Add a new card
                </Button>
              </Card>
            </div>
          </div>
        )}
      </div>

      <div>
        <div
          className="inventoryHeader mb-10"
          style={{ borderBottom: '1px solid #eaeaea' }}
        >
          <span className="inventoryHeading font-26px fw-300">Plans</span>
        </div>
        {loader ? (
          <Loading style={{ height: '30vh' }} />
        ) : (
          <div className={classes.container}>
            {Object.entries(plansInfo)
              .filter(([plan, features]) => {
                if (plan.toLowerCase() === 'free trial') {
                  return companyDetail?.PlanType?.toLowerCase() === 'free trial';
                }
                return true;
              })
              .sort(([planA], [planB]) => {
                if (planA.toLowerCase() === 'free trial') return -1;
                if (planB.toLowerCase() === 'free trial') return 1;
                return 0;
              })
              .map(([plan, features]) => (
                <Card
                  key={plan}
                  style={{ height: 'auto', maxHeight: '800px' }}
                  className={
                    `${user?.PlanType === plan &&
                      companyDetail?.SubscriptionStatus === 'active'
                      ? `${classes.card}  ${classes.activeCardBorder}`
                      : (companyDetail?.SubscriptionStatus === 'incomplete' ||
                        companyDetail?.SubscriptionStatus === 'past_due') &&
                        user?.PlanType === plan
                        ? `${classes.card} `
                        : classes.card
                    } ${companyDetail?.PlanType === 'Free Trial' ? classes.cardFourPerRow : ''}`
                  }
                >
                  <div className="B-outerContainer" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                    <CardContent className={classes.content} style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                      
                      {/* SECTION 1: Title, Price, and Icon */}
                      <Box className={
                        companyDetail?.PlanType === plan
                          ? classes.bgGreen
                          : classes.bgBlue
                      }>
                        <div className={classes.planHeaderSection}>
                          <Box sx={{ flex: 1 }}>
                            <Typography variant='h3'>
                              {plan}
                            </Typography>
                            {plan.toLowerCase() !== 'free trial' && (
                              <div className={classes.priceSection}>
                              {plansData.find(pln => pln.name === plan) ? (
                                <>
                                  <span className={classes.priceSymbol}>$</span>
                                  <span className={classes.priceAmount}>
                                    {plansData.find(pln => pln.name === plan)?.PlanPrice / 100}
                                  </span>
                                </>
                              ) : ''
                              } 
                              <Typography variant="h5" color="initial">/ month</Typography>
                              </div>
                            )}
                            {user?.PlanType === plan && (() => {
                              const start = new Date(companyDetail?.PlanDate).getTime();
                              const daysTotal = Number(companyDetail?.PlanDays) || 0;
                              const end = start + daysTotal * 24 * 60 * 60 * 1000;
                              const diffMs = end - Date.now();
                              const daysRemaining = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
                              return (
                                <span style={{ fontSize: '18px', color: daysRemaining <= 7 ? '#DC3545' : '#1a7f37', marginTop: '8px', display: 'inline-block' }}>
                                  {daysRemaining <= 0
                                    ? daysRemaining === 0
                                      ? 'Ends today'
                                      : 'Expired'
                                    : `Ends in ${daysRemaining} day${daysRemaining === 1 ? '' : 's'}`}
                                </span>
                              );
                            })()}
                          </Box>
                          
                          <Box className={classes.planIconWrapper}>
                            <img
                              src={getIconForPlan[plan]}
                              className={classes.iconSize} 
                              alt={`${plan} icon`}
                            />
                          </Box>
                        </div>
                      </Box>

                      {/* SECTION 2: Features */}
                      <Box className={classes.featuresSection} sx={{ flex: 1, maxHeight:'400px', overflowY: 'auto' }}>
                        {features.map((feature, index) => (
                          <div key={index} style={{ width: '100%' }}>
                            <div className={classes.feature}>
                              {feature}
                            </div>
                            {index < features.length - 1 && (
                              <div className={classes.featureDivider} />
                            )}
                          </div>
                        ))}
                      </Box>

                      {/* SECTION 3: Buttons */}
                      <Box className={classes.buttonsSection} sx={{display:'flex'}}>
                        {!user || loader ? (
                          <Button
                            variant="outlined"
                            className={classes.loadingButton}
                            fullWidth
                          >
                            loading...
                          </Button>
                        ) : user?.SubscriptionStatus &&
                          user?.PlanType === plan ? (
                          <div style={{ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'baseline', gap: '12px' }}>
                            {companyDetail?.SubscriptionStatus ===
                              'past_due' ||
                              companyDetail?.SubscriptionStatus ===
                              'incomplete' ? (
                              <div className={classes.pendingButton}>
                                <AccessTimeIcon style={{ fontSize: '20px', marginRight: '8px' }} />
                                <span style={{ fontSize: '16px' }}>
                                  Payment processing...
                                </span>
                              </div>
                            ) : companyDetail?.SubscriptionMode ===
                              'Auto Renewal' ? (
                              <Button
                                variant="text"
                                className={classes.button}
                                fullWidth
                                onClick={() => {
                                  history.push({
                                    pathname: Routes.PlanDetails,
                                    state: {
                                      ActiveFeatures:
                                        userDataState?.plan?.feature_limits,
                                      PlanPrice:
                                        +plansData?.find(
                                          (value) => value.name === plan
                                        )?.PlanPrice / 100,
                                      PlanImage: getIconForPlan[plan],
                                      PlanName: plan,
                                      PlanDate: companyDetail.PlanDate,
                                      PlanExpiryDays:
                                        companyDetail.PlanDays,
                                    },
                                  });
                                }}
                              >
                                Plan Details
                              </Button>
                            ) : (
                              <div>
                                <p
                                  style={{ 
                                    fontSize: '18px', 
                                    fontWeight: 600,
                                    color: '#DC3545',
                                    textAlign: 'center'
                                  }}
                                >
                                  Ends{' '}
                                  {user?.RemainingDays === 0
                                    ? 'today'
                                    : `in ${user?.RemainingDays === 1
                                      ? `${user?.RemainingDays} day`
                                      : `${user?.RemainingDays} days`
                                    }`}{' '}
                                </p>
                              </div>
                            )}
                            
                            {companyDetail?.PlanType === plan &&
                              companyDetail?.SubscriptionMode === 'Auto Renewal' && 
                              companyDetail?.SubscriptionStatus === 'active' ? (
                              <Button
                                fullWidth
                                variant="text"
                                className={classes.cancelSubButton}
                                onClick={() => {
                                  setCancelSubsModal(true);
                                  setPlan(plan);
                                }}
                              >
                                Cancel Subscription
                              </Button>
                            ) : null}
                          </div>
                        ) : plansData?.some(
                          (value) => value.name === plan
                        ) ? (
                          plansData?.some(
                            (value) =>
                              value.name === plan &&
                              value.status === 'active'
                          ) ? (
                            <Button
                              variant="contained"
                              fullWidth
                              onClick={() => {
                                setPlanChange(true);
                                setBuyModal(true);
                                setPlan(plan);
                                setAutoRenewal(false);
                              }}
                              className={classes.button}
                            >
                              Buy Now
                            </Button>
                          ) : (
                            <Button
                              variant="contained"
                              fullWidth
                              className={classes.disabledButton}
                            >
                              Quotation Requested
                            </Button>
                          )
                        ) : (
                          <Tooltip
                            title="Get a detailed plan quotation from our support team."
                            placement="bottom"
                          >
                            <Button
                              variant="contained"
                              fullWidth
                              onClick={() => {
                                setRequestQuoteModal(true);
                                setPlan(plan);
                              }}
                              className={classes.infoButton}
                            >
                              Request Quote
                            </Button>
                          </Tooltip>
                        )}
                      </Box>

                    </CardContent>
                  </div>
                </Card>
              ))}
          </div>
        )}
      </div>
      {requestQuoteModal && (
        <AlertModal
          show={requestQuoteModal}
          headerMsg="Request Quote"
          onClose={onRequestQuoteModal}
          metaData={'Are you sure you want to request for quotation'}
          alertFunction={() => handleRequestQuoteModal()}
          buttonMsg="Yes"
        />
      )}
      {deleteCardModal && (
        <AlertModal
          show={deleteCardModal}
          headerMsg="Delete"
          onClose={onDeleteCardModal}
          metaData={'Are you sure you want to remove card'}
          alertFunction={() => handleDeleteCard()}
          buttonMsg="Yes"
        />
      )}
      {cancelSubsModal && (
        <AlertModal
          show={cancelSubsModal}
          headerMsg="Plan"
          onClose={onCloseCancelSubsModal}
          metaData={`Are you sure you want to cancel ${plan} Plan`}
          alertFunction={() => handleCancelSubscription()}
          buttonMsg="Yes"
        />
      )}
      {buyModal && (
        <BuyNow
          show={buyModal}
          headerMsg="Plan"
          onClose={onCloseBuyModal}
          metaData={`Are you sure you want to purchase ${plan} Plan?`}
          buyNowFun={handleBillingCheckout}
          buttonMsg="Yes"
          AutoRenewal={autoRenewal}
          BuyNow={planChange}
        />
      )}
    </>
  );
};

export default Billing;
